import React, { useCallback } from 'react';
import { Box, ButtonBase } from '@mui/material';

import { Typography, Card, CardContent } from '@occc/ui-design-system';

export interface IOfferTypeItemProps {
  type: string;
  title: string;
  description: string;
  disabled?: boolean;
  icon: React.ComponentType;
  onClick: (type: string) => void;
}

const OfferTypeItem: React.FC<IOfferTypeItemProps> = ({
  type,
  onClick,
  icon: Icon,
  title,
  description,
  disabled,
}) => {
  const handleClick = useCallback(() => {
    onClick(type);
  }, [type, onClick]);

  return (
    <ButtonBase disabled={disabled} onClick={handleClick} sx={{ width: '100%', height: '100%' }}>
      <Card
        variant='outlined'
        elevation={0}
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          mb: 0,
        }}
      >
        <Box
          width={48}
          marginLeft={2}
          flexShrink={0}
          display='flex'
          sx={{
            '& > svg': {
              margin: 'auto',
            },
          }}
        >
          <Icon />
        </Box>
        <CardContent
          sx={{
            '&:last-child': {
              pb: 2,
              overflow: 'hidden',
            },
          }}
        >
          <Typography variant='subtitle1' component='p' gutterBottom align='left'>
            {title}
          </Typography>
          <Typography variant='body2' color='textSecondary' align='left'>
            {description}
          </Typography>
        </CardContent>
      </Card>
    </ButtonBase>
  );
};

export default OfferTypeItem;
